import { combineReducers } from "redux";
import { configureStore } from "@reduxjs/toolkit";
// import LoginPostSlice from "../Slices/Login/LoginPost";
import headerReducer from "../Slices/headerSlice";
import createDepartmentSlice from "../Slices/CreateDepartment/createDepartment";
import bulkUploadDepartmentsSlice from "../Slices/CreateDepartment/bulkUploadDepartments";
import downloadAllDepartmentsSlice from "../Slices/CreateDepartment/downloadAllDepartments";
import updateDepartmentSlice from "../Slices/CreateDepartment/updateDepartment";
import getDepartmentByIdSlice from "../Slices/CreateDepartment/getDepartmentById";
import getAllDepartmentsSlice from "../Slices/CreateDepartment/getAllDepartments";
import createSubDepartmentSlice from "../Slices/SubDepartment/createSubDepartment";
import downloadAllSubDepartmentsSlice from "../Slices/SubDepartment/downloadAllSubDepartments";
import updateSubDepartmentSlice from "../Slices/SubDepartment/updateSubDepartment";
import getSubDepartmentByIdSlice from "../Slices/SubDepartment/getSubDepartmentById";
import getAllSubDepartmentsSlice from "../Slices/SubDepartment/getAllSubDepartments";
import bulkUploadSubDepartmentsSlice from "../Slices/SubDepartment/bulkUploadSubDepartments";
import createDesignationSlice from "../Slices/Designation/createDesignation";
import bulkUploadDesignationsSlice from "../Slices/Designation/bulkUploadDesignations";
import downloadAllDesignationsSlice from "../Slices/Designation/downloadAllDesignations";
import updateDesignationSlice from "../Slices/Designation/updateDesignation";
import getAllDesignationsSlice from "../Slices/Designation/getAllDesignations";
import getDesignationByIdSlice from "../Slices/Designation/getDesignationById";
import createKraKpiSlice from "../Slices/KRA&KPI/createKraKpi";
import bulkUploadKraKpisSlice from "../Slices/KRA&KPI/bulkUploadKraKpis";
import downloadAllKraKpisSlice from "../Slices/KRA&KPI/downloadAllKraKpis";
import getAllKraKpiSlice from "../Slices/KRA&KPI/getAllKraKpi";
import getKraKpiByIdSlice from "../Slices/KRA&KPI/getKraKpiById";
import updateKraKpiSlice from "../Slices/KRA&KPI/updateKraKpi";
import createAppraisalYearSlice from "../Slices/YearOfDuration/createAppraisalYear";
import getAllAppraisalYearsSlice from "../Slices/YearOfDuration/getAllAppraisalYears";
import getAppraisalYearByIdSlice from "../Slices/YearOfDuration/getAppraisalYearById";
import updateAppraisalYearSlice from "../Slices/YearOfDuration/updateAppraisalYear";
import getSubDepartmentsByDepartmentIdSlice from "../Slices/SubDepartment/getSubDepartmentsByDepartmentId";
import getAllEmployeesSlice from "../Slices/AddEmployee/getAllEmployees";
import createEmployeeSlice from "../Slices/AddEmployee/createEmployee";
import getEmployeeByIdSlice from "../Slices/AddEmployee/getEmployeeById";
import updateEmployeeSlice from "../Slices/AddEmployee/updateEmployee";
import toggleEmployeeStatusSlice from "../Slices/AddEmployee/toggleEmployeeStatus";
import createKraKpiQuestionForkrakpiSlice from "../Slices/KraKpiQuestions/createKraKpiQuestionForkrakpi";
import getAllQuestionsSlice from "../Slices/KraKpiQuestions/getAllQuestions";
import getQuestionByIdSlice from "../Slices/KraKpiQuestions/getQuestionById";
import updateQuestionSlice from "../Slices/KraKpiQuestions/updateQuestion";
import getEmployeeKraKpiStatusListSlice from "../Slices/Employee/getEmployeeKraKpiStatusList";
import getAdminReportByAppraisalYearSlice from "../Slices/Employee/getAdminReportByAppraisalYear";
import getKraKpiAppraisalFormSlice from "../Slices/Employee/getKraKpiAppraisalForm";
import createKraKpiAnswerSlice from "../Slices/Employee/createKraKpiAnswer";
import uploadPdfAndImageSlice from "../Slices/UploadFile/uploadPdfAndImage";
import getManagersEmployeeKraKpiStatusListSlice from "../Slices/Employee/getManagersEmployeeKraKpiStatusList";
import updateManagerEvaluationSlice from "../Slices/Employee/updateManagerEvaluation";
import getReviewerEmployeeKraKpiStatusListSlice from "../Slices/Employee/getReviewerEmployeeKraKpiStatusList";
import rejectManagerEvaluationSlice from "../Slices/Employee/rejectManagerEvaluation";
import updateEmployeeEvaluationSlice from "../Slices/Employee/updateEmployeeEvaluation";
import submitReviewerEvaluationSlice from "../Slices/Employee/submitReviewerEvaluation";
import rejectReviewerEvaluationSlice from "../Slices/Employee/rejectReviewerEvaluation";
import requestAppraisalReapplySlice from "../Slices/Employee/requestAppraisalReapply";
import rejectAppraisalReapplySlice from "../Slices/Employee/rejectAppraisalReapply";
import acceptAppraisalReapplySlice from "../Slices/Employee/acceptAppraisalReapply";
import loginEmployeeSlice from "../Slices/Employee/loginEmployee";
import bulkUploadEmployeeFromExcelSlice from "../Slices/AddEmployee/bulkUploadEmployeeFromExcel";
import bulkUpdateKraKpiAnswersOfManagerAndReviewerEvalutationFromExcelSlice from "../Slices/KraKpiQuestions/bulkUpdateKraKpiAnswersOfManagerAndReviewerEvalutationFromExcel";
import downloadKraKpiAnswersOfManagerAndReviewerEvalutationSampleExcelFileSlice from "../Slices/KraKpiQuestions/downloadKraKpiAnswersOfManagerAndReviewerEvalutationSampleExcelFile";
import bulkUploadKraKpiQuestionsFromExcelSlice from "../Slices/KraKpiQuestions/bulkUploadKraKpiQuestionsFromExcel";
import downloadKraKpiQuestionsSampleExcelFileSlice from "../Slices/KraKpiQuestions/downloadKraKpiQuestionsSampleExcelFile";
import getAdminDashboardSlice from "../Slices/Dashboard/getAdminDashboard";
import getEmployeeDashboardSlice from "../Slices/Dashboard/getEmployeeDashboard";
import loginAuthUserSlice from "../Slices/Dashboard/loginAuthUser";
import getBellCurveReportByAppraisalYearSlice from "../Slices/UploadFile/getBellCurveReportByAppraisalYear";
import sendOTPSlice from "../Slices/ForgetPassword/sendOTP";
import verifyOTPSlice from "../Slices/ForgetPassword/verifyOTP";
import resetPasswordForEmployeeSlice from "../Slices/ForgetPassword/resetPasswordForEmployee";
import getEmployeeEmailByCodeSlice from "../Slices/ForgetPassword/getEmployeeEmailByCode";
import uploadMultiplePdfsSlice from "../Slices/UploadFile/uploadMultiplePdfs";
import pmsScoreShowHideSlice from "../Slices/Employee/pmsScoreShowHide";
import getAdminDashboardByYearSlice from "../Slices/Dashboard/getAdminDashboardByYear";
import saveSiteSettingsSlice from "../Slices/Dashboard/saveSiteSettings";
import getSiteSettingsSlice from "../Slices/Dashboard/getSiteSettings";
import uploadImageSlice from "../Slices/UploadFile/uploadImage";
import getEmployeeDashboardByYearSlice from "../Slices/Dashboard/getEmployeeDashboardByYear";
import getEmployeeByloginSlice from "../Slices/ForgetPassword/getEmployeeBylogin";
import getPdfsByAppraisalYearSlice from "../Slices/YearOfDuration/getPdfsByAppraisalYear";
import deletePdfByNameSlice from "../Slices/YearOfDuration/deletePdfByName";
import downloadPdfByNameSlice from "../Slices/YearOfDuration/downloadPdfByName";
import updateEmailConfigSlice from "../Slices/MailSettings/updateEmailConfig";
import getEmailConfigSlice from "../Slices/MailSettings/getEmailConfig";
import testEmailConnectionSlice from "../Slices/MailSettings/testEmailConnection";
import MicrosoftUsersyncSlice from "../Slices/MailSettings/MicrosoftUsersync";
import bulkUpdateEmployeeFromExcelSlice from "../Slices/AddEmployee/bulkUpdateEmployeeFromExcel";
import bulkUpdateActiveDeactiveEmployeeFromExcelSlice from "../Slices/AddEmployee/bulkUpdateActiveDeactiveEmployeeFromExcel";
import getAppraisalYearPmsScoreStatusByYearSlice from "../Slices/Employee/getAppraisalYearPmsScoreStatusByYear";

const reducer = combineReducers({
  // LoginPost: LoginPostSlice,
  header: headerReducer,

  createDepartment: createDepartmentSlice,
  bulkUploadDepartments: bulkUploadDepartmentsSlice,
  downloadAllDepartment: downloadAllDepartmentsSlice,
  updateDepartment: updateDepartmentSlice,
  getDepartmentById: getDepartmentByIdSlice,
  getAllDepartments: getAllDepartmentsSlice,

  createSubDepartment: createSubDepartmentSlice,
  bulkUploadSubDepartments: bulkUploadSubDepartmentsSlice,
  downloadAllSubDepartments: downloadAllSubDepartmentsSlice,
  updateSubDepartment: updateSubDepartmentSlice,
  getSubDepartmentById: getSubDepartmentByIdSlice,
  getAllSubDepartments: getAllSubDepartmentsSlice,

  createDesignation: createDesignationSlice,
  bulkUploadDesignations: bulkUploadDesignationsSlice,
  downloadAllDesignations: downloadAllDesignationsSlice,
  updateDesignation: updateDesignationSlice,
  getDesignationById: getDesignationByIdSlice,
  getAllDesignations: getAllDesignationsSlice,

  createKraKpi: createKraKpiSlice,
  bulkUploadKraKpis: bulkUploadKraKpisSlice,
  downloadAllKraKpis: downloadAllKraKpisSlice,
  getAllKraKpi: getAllKraKpiSlice,
  getKraKpiById: getKraKpiByIdSlice,
  updateKraKpi: updateKraKpiSlice,

  createAppraisalYear: createAppraisalYearSlice,
  getAllAppraisalYears: getAllAppraisalYearsSlice,
  getAppraisalYearById: getAppraisalYearByIdSlice,
  updateAppraisalYear: updateAppraisalYearSlice,

  getSubDepartmentsByDepartmentId: getSubDepartmentsByDepartmentIdSlice,

  getAllEmployees: getAllEmployeesSlice,
  createEmployee: createEmployeeSlice,
  getEmployeeById: getEmployeeByIdSlice,
  updateEmployee: updateEmployeeSlice,
  toggleEmployeeStatus: toggleEmployeeStatusSlice,
  createKraKpiQuestionForkrakpi: createKraKpiQuestionForkrakpiSlice,

  getAllQuestions: getAllQuestionsSlice,
  getQuestionById: getQuestionByIdSlice,
  updateQuestion: updateQuestionSlice,

  getEmployeeKraKpiStatusList: getEmployeeKraKpiStatusListSlice,

  getAdminReportByAppraisalYear: getAdminReportByAppraisalYearSlice,
  getKraKpiAppraisalForm: getKraKpiAppraisalFormSlice,

  createKraKpiAnswer: createKraKpiAnswerSlice,
  uploadPdfAndImage: uploadPdfAndImageSlice,

  getManagersEmployeeKraKpiStatusList: getManagersEmployeeKraKpiStatusListSlice,
  updateManagerEvaluation: updateManagerEvaluationSlice,
  getReviewerEmployeeKraKpiStatusList: getReviewerEmployeeKraKpiStatusListSlice,

  rejectManagerEvaluation: rejectManagerEvaluationSlice,
  rejectReviewerEvaluation: rejectReviewerEvaluationSlice,
  submitReviewerEvaluation: submitReviewerEvaluationSlice,

  updateEmployeeEvaluation: updateEmployeeEvaluationSlice,

  requestAppraisalReapply: requestAppraisalReapplySlice,
  rejectAppraisalReapply: rejectAppraisalReapplySlice,
  acceptAppraisalReapply: acceptAppraisalReapplySlice,

  loginEmployee: loginEmployeeSlice,
  bulkUploadEmployeeFromExcel: bulkUploadEmployeeFromExcelSlice,
  bulkUpdateKraKpiAnswersOfManagerAndReviewerEvalutationFromExcel:
    bulkUpdateKraKpiAnswersOfManagerAndReviewerEvalutationFromExcelSlice,
  downloadKraKpiAnswersOfManagerAndReviewerEvalutationSampleExcelFile:
    downloadKraKpiAnswersOfManagerAndReviewerEvalutationSampleExcelFileSlice,

  bulkUploadKraKpiQuestionsFromExcel: bulkUploadKraKpiQuestionsFromExcelSlice,
  downloadKraKpiQuestionsSampleExcelFile:
    downloadKraKpiQuestionsSampleExcelFileSlice,
  getAdminDashboard: getAdminDashboardSlice,
  getEmployeeDashboard: getEmployeeDashboardSlice,

  getBellCurveReportByAppraisalYear: getBellCurveReportByAppraisalYearSlice,

  loginAuthUser: loginAuthUserSlice,

  sendOTP: sendOTPSlice,
  verifyOTP: verifyOTPSlice,
  resetPasswordForEmployee: resetPasswordForEmployeeSlice,
  getEmployeeEmailByCode: getEmployeeEmailByCodeSlice,

  uploadMultiplePdfs: uploadMultiplePdfsSlice,

  pmsScoreShowHide: pmsScoreShowHideSlice,

  getAdminDashboardByYear: getAdminDashboardByYearSlice,

  saveSiteSettings: saveSiteSettingsSlice,
  getSiteSettings: getSiteSettingsSlice,

  uploadImage: uploadImageSlice,

  getEmployeeDashboardByYear: getEmployeeDashboardByYearSlice,

  getEmployeeBylogin: getEmployeeByloginSlice,

  getPdfsByAppraisalYear: getPdfsByAppraisalYearSlice,
  deletePdfByName: deletePdfByNameSlice,
  downloadPdfByName: downloadPdfByNameSlice,

  updateEmailConfig: updateEmailConfigSlice,
  getEmailConfig: getEmailConfigSlice,
  testEmailConnection: testEmailConnectionSlice,
  MicrosoftUsersync: MicrosoftUsersyncSlice,
  bulkUpdateEmployeeFromExcel: bulkUpdateEmployeeFromExcelSlice,
  bulkUpdateActiveDeactiveEmployeeFromExcelAction:bulkUpdateActiveDeactiveEmployeeFromExcelSlice,
  
  getAppraisalYearPmsScoreStatusByYear:getAppraisalYearPmsScoreStatusByYearSlice,
});

const store = configureStore({
  reducer,
});
export default store;
